import React from 'react';
import { useBanners } from '../../hooks/useBanners';
import { BANNER_CATEGORY } from '../../constants/bannerCategory';
import AntdCarousel from './AntdCarousel';

const MainBanner = () => {
  const { banners, loading, handleBannerClick } = useBanners(
    BANNER_CATEGORY.MAIN,
  );

  return (
    <AntdCarousel
      bannerItems={banners}
      loading={loading}
      handleBannerClick={handleBannerClick}
    />
  );
};

export default MainBanner;
